import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as d3 from 'd3';
import _ from 'lodash';
import { ColorEnum } from '../../enum/colors.enum';

export interface ProfilOption {
  weight: number;
  color: string;
  width?: number;
  height?: number
}

@Component({
  selector: 'aoe-race-profil',
  templateUrl: './race-profil.component.html',
  styleUrls: ['./race-profil.component.scss'],
  imports: [CommonModule]
})
export class RaceProfilComponent implements OnInit, AfterViewInit {

  @ViewChild('profilWrapper') profilWrapper!: ElementRef;


  @Input()
  data!: Array<any>;

  @Input()
  profilOption: ProfilOption = { color: ColorEnum.$DEFAULT_BLUE, weight: 3 };

  @Input()
  checkpoints!: Array<any>;

  @Input()
  min!: number;

  @Input()
  max!: number;

  @Input()
  raceLocation!: { start: string | undefined | null, arrival: string | undefined | null };

  @Output()
  coordinatesHovering = new EventEmitter();


  private readonly margin = 30;
  private width!: number;
  private readonly height = 200;

  public svg: any;
  public svgInner: any;
  public yScale: any;
  public xScale: any;
  public xAxis: any;
  public yAxis: any;
  public lineGroup: any;

  public displayPopUp = false;
  public checkpointSelected!: any | null;

  constructor(public chartElem: ElementRef) {
  }

  ngOnInit(): void {
    const elevations = this.data?.map(d => d.elevation).sort((a, b) => {
      return a - b;
    })

    if (elevations) {
      this.min = elevations[0];
      this.max = elevations[elevations.length - 1];

      this.min = this.min - (((this.min + this.max) / 2) * .1)
      this.max = this.max + (((this.min + this.max) / 2) * .1)
    }

  }

  ngAfterViewInit(): void {
    this.width = this.profilWrapper?.nativeElement.offsetWidth

    if (this.profilOption) {
      if (this.data && this.min && this.max) {
        this.svg = d3
          .select(this.chartElem.nativeElement)
          .select('.race-profil')
          .append('svg')
          .attr('height', this.height)
          .attr('margin', this.margin)
          .attr('width', this.width)

        this.svgInner = this.svg
          .append('g')
          .attr('height', this.height)
          .attr('width', this.width)
          .style('transform', `translate(${this.margin}px,0px)`);

        this.yScale = d3
          .scaleLinear()
          .domain([this.max, this.min])
          .range([0, this.height - 2 * this.margin]);

        this.xScale = d3
          .scaleLinear()
          .domain([0, this.data[this.data.length - 1].distance])
          .range([this.margin, this.width - 2 * this.margin])

        this.yAxis = this.svgInner
          .append('g')
          .attr('id', 'y - axis')
          .style('transform', 'translate(-20px, 0)');

        this.xAxis = this.svgInner
          .append('g')
          .attr('id', 'px - axis')
          .style('transform', 'translate(0, ' + (this.height - 2 * this.margin) + 'px)');

        this.lineGroup = this.svgInner
          .append('g')
          .append('path')
          .attr('id', 'line')
          .style('fill', 'none')
          .style('stroke', this.profilOption.color)
          .style('stroke-width', this.profilOption.weight)
        // .on('mouseover', (event: any) => {
        // });

        const points: [number, number, number, number][] = this.data.map(
          (d: any) => {
            return [this.xScale(d.distance), this.yScale(d.elevation), d.coordinates?.lat, d.coordinates?.lng]
          }
        );


        points.forEach((p, i) => {
          const nextPoint = i === points.length - 1 ? p : points[i + 1]
          this.svgInner
            .append('g')
            .append('rect')
            .attr('x', p[0])
            .attr('y', this.yScale(this.max))
            .attr('width', nextPoint[0] - p[0])
            .attr('height', this.yScale(this.min))
            // .attr('x1', p[0])
            // .attr('x2', nextPoint[0])
            // .attr('y1', this.yScale(this.max))
            // .attr('y2', this.yScale(this.min))
            .attr('fill', 'white')
            .attr('fill-opacity', '0')
            .attr('lat', p[2])
            .attr('lng', p[3])
            .on('mouseover', (event: any) => {
              this.coordinatesHovering.emit({
                lat: event.target.attributes.lat.value,
                lon: event.target.attributes.lng.value
              })
            })
            .on('mouseleave', () => {
              this.coordinatesHovering.emit(null)
            });
        })

        /** START PROFIL POINT */
        // if (this.checkpoints && this.checkpoints[0].distance !== 0) {
        //   this.svgInner
        //     .append('g')
        //     .append('line')
        //     .attr('x1', 0 + this.margin)
        //     .attr('x2', 0 + this.margin)
        //     .attr('y1', this.yScale(this.data[0].elevation))
        //     .attr('y2', this.yScale(this.min))
        //     .attr('stroke', this.profilOption.color)
        //     .attr('stroke-width', 2)

        //   this.svgInner
        //     .append('g')
        //     .append('circle')
        //     .style("stroke", "gray")
        //     .style("stroke-weight", 2)
        //     .style("fill", this.profilOption.color)
        //     .attr("r", 5)
        //     .attr("cx", 0 + this.margin)
        //     .attr("cy", this.yScale(this.data[0].elevation));

        //   this.svgInner
        //     .append('text')
        //     .text(this.raceLocation.start)
        //     .attr('y', this.yScale(this.min))
        //     .attr('x', 0 + this.margin + 5)
        //     .attr("font-size", 12)
        // }

        if (this.checkpoints) {
          this.generateInterDistance(this.svgInner);
          this.checkpoints.forEach((c, index) => {
            this.svgInner
              // .style('transform', `translate(${this.margin}, 0)`)
              .append('line')
              .attr('x1', this.xScale(c.distance / 1000))
              .attr('x2', this.xScale(c.distance / 1000))
              .attr('y1', this.yScale(this.min))
              .attr('y2', this.yScale(c.elevation.elevation))
              .attr('stroke', this.profilOption.color)
              .attr('stroke-width', .5)
              .style('z-index', 10)
            this.svgInner
              .append('circle')
              .style("stroke", "gray")
              .style("stroke-weight", 2)
              .style("fill", this.profilOption.color)
              .style('cursor', 'pointer')
              .attr("r", 5)
              .attr("cx", this.xScale(c.distance / 1000))
              .attr("cy", this.yScale(c.elevation.elevation))
              .on('click', () => {
                this.displayPopUp = true;
                this.checkpointSelected = c;
              })

            // if (index !== this.checkpoints.length - 1 && c.distance > 0)
            //   this.svgInner
            //     .append('g')
            //     .append('circle')
            //     .style("stroke", "gray")
            //     .style("stroke-weight", 2)
            //     .style("fill", this.profilOption.color)
            //     .attr("r", 25)
            //     .attr("cx", this.xScale(c.distance / 1000))
            //     .attr("cy", this.yScale(this.max + 50))
            //     .append("foreignObject")
            //     .append('h1')
            //     .text('test')

            this.svgInner
              .append('text')
              .text(c.name)
              .style('transform', `translate(${index === (this.checkpoints ? this.checkpoints.length : 0) - 1 ? '-5px' : '5px'}, -5px)`)
              .attr('y', this.yScale(this.min))
              .attr('x', this.xScale(c.distance / 1000))
              .attr("font-size", 12)
              .style('text-anchor', (this.checkpoints.length - 1) === index ? 'end' : 'start')

          });

        }




        const yAxis = d3
          .axisRight(this.yScale)
          .ticks(4);


        this.yAxis
          .call(yAxis)
          .call((g: any) => g.select('.domain').remove())
          .call((g: any) => g.selectAll(".tick line")
            .attr("stroke-opacity", 0.4)
            .attr("stroke-dasharray", "1,2")
            .attr('x1', this.xScale(0) + 20)
            .attr('x2', this.xScale(this.data[this.data.length - 1].distance))
            .style('tranform', `translate(20px, 0)`)
          )

        const line = d3
          .line()
          .x(d => d[0])
          .y(d => d[1])
          .curve(d3.curveBasis);


        this.lineGroup.attr('d', line(points.map(p => [p[0], p[1]])));
      }
    }
  }

  private generateInterDistance(svgInner: any) {
    if (this.checkpoints.length > 1) {
      this.checkpoints.sort((a, b) => a.distance - b.distance).forEach((c, index) => {
        if (index < this.checkpoints.length - 1) {
          svgInner
            .append('g')
            .append('rect')
            .attr('x', c.distance === 0 ? c.distance + this.margin : this.xScale((c.distance / 1000)))
            .attr('y', this.yScale(this.min))
            .attr('width', this.xScale((this.checkpoints[index + 1].distance / 1000 - (index === 0 ? 0 : this.checkpoints[index].distance / 1000))) - this.margin)
            // .attr('width', this.xScale(10))
            .attr('height', 20)
            .attr('stroke-left', 'black')
            .attr('fill', 'lightgray')

          svgInner
            .append('text')
            .attr('x', ((this.xScale(this.checkpoints[index + 1].distance / 1000) - this.xScale(c.distance / 1000)) / 2) + this.xScale(c.distance / 1000))
            .attr('y', 14)
            .attr('dy', this.yScale(this.min - 15))
            .attr('font-size', 14)
            .style('text-anchor', 'middle')
            .text(`${Math.floor(((this.checkpoints[index + 1].distance - c.distance) / 1000) * 100) / 100}KM`)
        }
      });
    }
  }

  public closeModal() {
    this.displayPopUp = false;
    this.checkpointSelected = null
  }

  public getServicesIcon(serviceKey: any): string {
    const basePath = '/assets/icons/svg/';
    switch (serviceKey) {
      case 'refreshment':
        return `${basePath}refreshment.svg`;

      case 'medical':
        return `${basePath}medical.svg`;
      case 'toilet':
        return `${basePath}toilet.svg`;
      case 'shower':
        return `${basePath}shower.svg`;
      case 'bus':
        return `${basePath}bus.svg`;
      case 'parking':
        return `${basePath}parking.svg`;
      default:
        return '';
    }
  }

  get checkpointsOptions(): any {
    if (this.checkpointSelected) {
      return this.checkpointSelected.options;
    }
    return {};
  }

  get hasMinMaxData() {
    return !_.isNil(this.min) && !_.isNil(this.max)
  }

}
